import { render, staticRenderFns } from "./ProjectManagerField.vue?vue&type=template&id=025af40e"
import script from "./ProjectManagerField.vue?vue&type=script&lang=js"
export * from "./ProjectManagerField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports